<script>
    import Form from './Form.svelte';
    import {form} from "../stores/store";

    export let formTitle;
</script>

<h2 class="form-header">{formTitle}</h2>
<hr>

{#if form && $form.success}
    <p class="form-success">Спасибо! Ваш отзыв отправлен на модерацию.</p>
{:else}
    <Form/>
{/if}

<style>
    .form-header {
        color: var(--main-color, #a06840);
        margin: 0 0 12px;
    }

    .form-success {
        font-size: 16px;
        line-height: 1.4;
        padding: 16px 0;
    }
</style>
